import React from "react";
import ButtonComponent from "./ButtonComponent";
import { FaceBookIcon, GoogleIcon } from "../assets/constants/Icons";
import { useTranslation } from "react-i18next";

const AuthButtons = ({ LoginWithFacebookHandler, LoginWithGoogleHandler, 
                    isLoginWithFacebook, isLoginWithGoogle, linkMyDevice,linkMyDeviceHandler }) => {
  const { t } = useTranslation();
  return (
    <div className="auth-container">
      <p className="auth-title">{t('sign_in_with_text')}</p>

      <div className="auth-buttons">
        {isLoginWithFacebook &&
        <ButtonComponent
            type="auth"
            buttonId="login-with-facebook-button"
            handleClick={LoginWithFacebookHandler}
            customClass="auth-button"
            centerIcon={<FaceBookIcon />}
        />}

      {isLoginWithGoogle &&
      <ButtonComponent
          type="auth"
          buttonId="login-with-google-button"
          handleClick={LoginWithGoogleHandler}
          customClass="auth-button"
          centerIcon={<GoogleIcon />}
      />}

    <ButtonComponent
        type="auth"
        handleClick={()=>{}}
        customClass="auth-button"
        centerIcon={<span className="plus-icon">+</span>}
    />
     {
      linkMyDevice &&
      <ButtonComponent type="auth" buttonId='link-my-device-button' 
          handleClick={linkMyDeviceHandler}
          centerIcon={<GoogleIcon /> } 
      />
     }
      </div>
    </div>
  );
};

export default AuthButtons;
